import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../css/components/SlickCarousel.scss";

class SlickCarousel extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className={`slick-carousel-wrapper ${this.props.className || ""}`}>
        <Slider ref={this.props.context} {...this.props.settings}>
          {this.props.children}
        </Slider>
        {this.props.title && <h2>{this.props.title}</h2>}
        {this.props.closeIcon && <this.props.closeIcon onClickCloseIcon={this.props.onClickCloseIcon} />}
      </div>
    );
  }
}

export default SlickCarousel;
